export class BookingApproveModel {
  bookingMasterHashId: string;
  bookingMasterHashIds : string[] = [];
  refrenceId: string;
  isApproved: boolean = true;
  adminRemarks: string;
  isReccuring: boolean = false;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/models/booking-approve.model.ts